import { ROUTES } from 'shared/constants';
import { getLanguageAndCountry } from './getLanguageAndCountry';
import { getLocaleString } from './getLocaleString';

const setInitialLanguageAttribute = () => {
  const { languageCode, countryCode } = getLanguageAndCountry();
  const locale = getLocaleString(languageCode, countryCode);

  document.documentElement.lang = languageCode;

  Object.values(ROUTES).forEach((route) => {
    const cleanRoute = route.replace('/', '');
    if (locale === cleanRoute) {
      document.documentElement.lang = navigator.language;
    }
  });
};

export default setInitialLanguageAttribute;
